import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    userTicketSection: {
        position: 'fixed',
        bottom: '10px',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 1400,
        pointerEvents: 'none'
    }
}));

export default useStyles;
